/**
 * Centralized configuration management for the React application
 * All environment variables and app settings are managed here
 */

const config = {
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
    endpoints: {
      students: '/api/students',
      auth: '/api/auth',
      health: '/api/health'
    }
  },

  // Application Settings
  app: {
    name: process.env.REACT_APP_APP_NAME || 'Student Management System',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',
    buildDate: process.env.REACT_APP_BUILD_DATE || new Date().toISOString()
  },

  // Feature Flags
  features: {
    debugMode: process.env.REACT_APP_ENABLE_DEBUG_MODE === 'true',
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    errorReporting: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
    devTools: process.env.REACT_APP_ENABLE_DEV_TOOLS === 'true'
  },

  // External Services
  services: {
    analyticsId: process.env.REACT_APP_ANALYTICS_ID || null,
    sentryDsn: process.env.REACT_APP_SENTRY_DSN || null
  },

  // Environment Helpers
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',

  // Validation
  validate() {
    const required = [
      'REACT_APP_API_URL'
    ];

    const missing = required.filter(key => !process.env[key]);
    
    if (missing.length > 0) {
      console.warn('Missing required environment variables:', missing);
    }

    return missing.length === 0;
  },

  // Debug helper
  debug() {
    if (this.features.debugMode) {
      console.group('🔧 App Configuration');
      console.log('Environment:', this.app.environment);
      console.log('API URL:', this.api.baseUrl);
      console.log('Features:', this.features);
      console.log('Build Date:', this.app.buildDate);
      console.groupEnd();
    }
  }
};

// Validate configuration on import
config.validate();

// Show debug info in development
if (config.isDevelopment) {
  config.debug();
}

export default config;